const Layout = () => import('@/layout/index.vue')

export default {
    path: '/problem',
    component: Layout,
    redirect: '/problem/index',
    name: 'Problem',
    meta: {
        title: '问题与需求',
        icon: 'problem'
    },
    children: [
        {
            path: 'index',
            name: 'ProblemIndex',
            component: () => import('@/views/problem/index.vue'),
            meta: {
                title: '问题与需求',
                sidebar: false,
                breadcrumb: false,
                activeMenu: '/problem',
                auth: ['problem']
            }
        }
    ]
}
